import React, { useEffect, useRef, useState } from 'react';
import { animate, motion, useInView } from 'framer-motion';
import { useMotionMode } from '../../contexts/MotionContext';

export const CountUp = ({ value, suffix = '', className = '', testId }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.6 });
  const { cinematic, reduced } = useMotionMode();
  const [display, setDisplay] = useState(reduced ? value : 0);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!inView || reduced) return undefined;
    const opts = cinematic
      ? { type: 'spring', stiffness: 35, damping: 14 }
      : { duration: 1.8, ease: [0.22, 1, 0.36, 1] };
    const controls = animate(0, value, {
      ...opts,
      onUpdate: (v) => setDisplay(Math.max(0, Math.round(v))),
      onComplete: () => setDone(true),
    });
    return () => controls.stop();
  }, [inView, value, cinematic, reduced]);

  return (
    <motion.span
      ref={ref}
      className={`inline-block tabular-nums ${className}`}
      animate={cinematic && done ? { scale: [1, 1.12, 1] } : { scale: 1 }}
      transition={{ duration: 0.5 }}
      data-testid={testId}
    >
      {display}
      {suffix}
    </motion.span>
  );
};
